import api from "../api/axiosInstance";

const roleService = {
  getAll: () => api.get("/roles"),
  create: (data) => api.post("/roles", data),
  update: (id, data) => api.put(`/roles/${id}`, data),
  delete: (id) => api.delete(`/roles/${id}`),
};

export default roleService;
